import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id 6FFC7116-2E5B-40A8-A612-90706DC5EECF
 * name expansion-card
 * version: 2.2.43
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/expansion-card.svg
 * tags
 * - Gaming / RPG 
 */
export const ExpansionCardIcon = createSvgIcon(<><path d="M2,7V8.5H3V17H4.5V7C3.7,7 2.8,7 2,7M6,7V7L6,16H7V17H14V16H22V7H6M17.5,9A2.5,2.5 0 0,1 20,11.5A2.5,2.5 0 0,1 17.5,14A2.5,2.5 0 0,1 15,11.5A2.5,2.5 0 0,1 17.5,9Z" /></>, 'ExpansionCardIcon');
export default ExpansionCardIcon